module.exports = "<div class=\"content-logo\">\r\n    <img class=\"responsive\" src=\"/logos/logo_1.png\"/>\r\n</div>"